import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import BrandsSinglePersonaDetail from './BrandsSinglePersonaDetail';
import { getHighestIndexOrPercentBrands } from '../../../util/Insight360Utils';

class BrandsSinglePersona extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRadioButton: 'index',
    };
  }

  resizeArray = (arr, newSize, defaultValue) => {
    while (newSize > arr.length) arr.push(defaultValue);
  }

  fillArray(brandsOrMedia) {
    if (brandsOrMedia.length === 0) {
      this.resizeArray(brandsOrMedia, 1, {
        iconCategory: 'NA',
        brandCategory: 'N/A',
        brandLabel: 'N/A',
        icon: 'clear-field-icon_190-190-190.png',
        index: 'N/A',
        weighted: 'N/A',
        sample: 'N/A',
        pct: 'N/A',
      });
      return brandsOrMedia;
    }
    return brandsOrMedia;
  }

  render() {
    let brandsGroupList = [];
    // let brandCategory = '';
    let highestIndex = 0;
    if (this.props.brands !== undefined) {
      brandsGroupList = this.props.brands;
      if (brandsGroupList.length === 0) {
        brandsGroupList = this.fillArray(brandsGroupList);
      }
      // brandCategory = brandsGroupList.brandCategory;
      highestIndex = getHighestIndexOrPercentBrands(
        brandsGroupList,
        this.state.selectedRadioButton,
      );
    }
    return (
      <div className="row fullwidth">
        <div className="large-1 medium-1 small-1 columns">
          <span>&nbsp;</span>
        </div>
        <div
          className="large-10 medium-10 small-10 columns"
          id="profileSinglePersona"
        >
          <div className="row fullwidth">
            {brandsGroupList.length > 0 &&
              brandsGroupList.map((details, i) => (<div className="row fullwidth" key={`brand-s${i}`}>
                <div className="columns large-12 small-12 medium-12">
                  <BrandsSinglePersonaDetail
                    highestIndex={highestIndex}
                    brandsDetail={details}
                    selectedTab={this.props.selectedTab}
                    personaIndex={0}
                    insight360studyInfo={this.props.insight360studyInfo}
                    selectedIcon={_.camelCase(
                      details.icon.replace('.png', ''),
                    )}
                  />
                </div>
              </div>
              )
              )}
          </div>
        </div>
        <div className="large-1 medium-1 small-1 columns">
          <span>&nbsp;</span>
        </div>
      </div>
    );
  }
}

BrandsSinglePersona.propTypes = {
  brands: PropTypes.arrayOf(PropTypes.object),
  insight360studyInfo: PropTypes.shape({}),
  selectedTab: PropTypes.string,
};

export default connect(
  null,
  null,
  null,
  { forwardRef: true },
)(BrandsSinglePersona);
